// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1Jx49","footer":"ModalUpdate_footer__1WwO2"};